<script setup>
import { onBeforeUnmount, ref, watch } from "vue";
import bootstrap from "bootstrap/dist/js/bootstrap";

const props = defineProps({
  text: { type: String, default: "" },
  disabled: { type: Boolean, default: false },
  placement: { type: String, default: "top" },
});

const tooltipInstance = ref(null);
const trigger = ref(null);
const triggerProps = ref({
  ref: setTriggerRef,
});

function setTriggerRef(el) {
  trigger.value = el?.$el ?? el;
}

watch(trigger, (el) => {
  if (el) {
    tooltipInstance.value = new bootstrap.Tooltip(el, {
      html: true,
      title: () => props.text,
      placement: props.placement,
      disabled: props.disabled,
      trigger: "hover",
      popperConfig: (defaultConfig) => ({
        ...defaultConfig,
        placement: props.placement,
      }),
    });

    if (props.disabled) {
      tooltipInstance.value?.disable();
    }
  }
});

watch(
  () => props.text,
  (text) => {
    tooltipInstance.value?.setContent({ ".tooltip-inner": text || "" });
  },
);

watch(
  () => props.disabled,
  (disabled) => {
    if (disabled) {
      tooltipInstance.value?.hide();
      tooltipInstance.value?.disable();
    } else {
      tooltipInstance.value?.enable();
    }
  },
);

onBeforeUnmount(() => {
  if (tooltipInstance.value) {
    tooltipInstance.value.dispose();
  }
});
</script>

<template>
  <slot :props="triggerProps" name="trigger"></slot>
</template>
